import axios from 'axios'

// back (DRF) の検証エラーを 1 行に畳む。
//
// **何が悪いのかは back しか知らない** —— 区分なし行を含む束 / 条件の桁あふれ / 指導文が空、は
// いずれも front からは事前に判らない (front で先に弾いているのは 2 つだけ)。一律「保存に
// 失敗しました」に潰すと、直しようが無いまま同じ操作を繰り返させることになる。
//
// 共有の `getErrorMessage` は `data.message` しか見ないので DRF の形に当たらない
// (400 が「入力内容に問題があります」までしか出ない)。共有側を触ると全画面に効くので、
// ここは定型文の画面に閉じた薄い写像にしてある。
//
// DRF が返す形はネストしうる:
//   {"lines": ["SOAP 区分を選んでください"]}                 ← Serializer.validate_lines
//   {"lines": [{"content": ["指導文が空です"]}, {}]}          ← 行ごとの検証 (many=True)
//   {"condition2": ["この項目が 100 文字より…"]}              ← モデル由来の桁
//   {"detail": "..."}                                        ← 権限・404 等
const flatten = (value: unknown): string[] => {
  if (typeof value === 'string') return [value]
  if (Array.isArray(value)) return value.flatMap(flatten)
  if (value && typeof value === 'object') {
    return Object.values(value as Record<string, unknown>).flatMap(flatten)
  }
  return []
}

export const soapSetErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  // `!error` を先に見るのは axios 0.21 の `isAxiosError` が
  // `typeof payload === 'object' && payload.isAxiosError` で、null を渡すと投げるため。
  if (!error || !axios.isAxiosError(error)) return fallback
  const first = flatten(error.response?.data).find((m) => m.trim() !== '')
  return first ?? fallback
}
